export const initialState = {
  questionnaire: {
    questionnaireId: null,
    siteId: 0,
    name: '',
    code: '',
    defaultYN: false,
    validFrom: null,
    validTo: null,
    isHistory: false,
    version: 1,
    active: false,
    filterFormula: '',
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  // eslint-disable-next-line no-unused-vars
  const { questions, questionActions, ...questionnaire } = action.data;
  return {
    ...state,
    questionnaire: { ...questionnaire, changed: false }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    questionnaire: {
      ...state.questionnaire,
      [propertyName]: value,
      changed: true
    }
  };
}

function onHeaderSaved(state, action) {
  const { questionnaireId } = action;
  return {
    ...state,
    questionnaire: {
      ...state.questionnaire,
      questionnaireId: questionnaireId,
      changed: false
    }
  };
}
